import servicio from "./axiosServices";

export function obtenerReviews(cursoId) {
  return servicio.get("Review/" + cursoId + "/1/100");
}
